import { render, staticRenderFns } from "./InterfaceDepend.vue?vue&type=template&id=1713c894&scoped=true"
import script from "./InterfaceDepend.vue?vue&type=script&lang=js"
export * from "./InterfaceDepend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713c894",
  null
  
)

export default component.exports